<template>
  <div class="audio-setting-component">
    <div class="check-item micro-box">
      <div class="check-item__title">麦克风</div>
      <div class="check-item__content">
        <el-select
          v-model="micro"
          placeholder="请选择"
          popper-class="device-check-popper"
          class="live-room-el-select"
          :disabled="
            userStatus.is_up_stage !== 1 ||
            (userStatus.is_send_audio !== 1 && roomInfo.isStudent)
          "
        >
          <el-option
            v-for="item in microphoneOptions"
            :key="item.deviceId"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
        <div class="test-volume">
          <img
            src="@saas/pages/assets/images/live/live-set/audio-icon.png"
            alt=""
          />
          <volume-test
            class="test-volume-box"
            :volume="microTestVolume"
            :boxCount="11"
          ></volume-test>
        </div>
      </div>

      <div class="mic-enhance-box">
        <div class="check-item__title">麦克风增强</div>
        <el-slider
          class="slider-box"
          v-model="micEnhanceVolume"
          :min="100"
          :max="150"
          :step="10"
          show-stops
          :marks="micMarks"
          @change="changeMicEnhanceVolume"
        ></el-slider>
      </div>
      <div class="ans-box">
        <div class="check-item__title">AI降噪</div>
        <el-switch
          v-model="ansEnabled"
          active-color="#165dff"
          inactive-color="#52525b"
          @change="changeANS"
        />
      </div>
    </div>
    <!-- todo：声音控制、检测 -->
    <div class="check-item speaker-box">
      <div class="check-item__title">扬声器</div>
      <div class="check-item__content">
        <div class="select-box">
          <el-select
            v-model="speaker"
            placeholder="请选择"
            popper-class="device-check-popper"
            class="live-room-el-select"
          >
            <el-option
              v-for="item in speakerOptions"
              :key="item.deviceId"
              :label="item.deviceName"
              :value="item.deviceId"
            >
            </el-option>
          </el-select>
          <el-button
            @click="onClickCheckSpeaker"
            class="check-btn__speaker"
            :class="{ 'check-btn__speaker--play': speakerPlaying }"
          >
            <img
              v-if="!speakerPlaying"
              src="@saas/pages/assets/images/live/speaker-1.png"
              alt=""
            />
            <img
              v-else
              src="@saas/pages/assets/images/live/speaker.gif"
              alt=""
            />
            检测
          </el-button>
        </div>
        <div class="test-volume test-volume-speaker">
          <img src="@saas/pages/assets/images/live/speaker.png" alt="" />
          <el-slider
            class="slider-box"
            v-model="speakerVolume"
            :max="100"
            @input="inputSpeakerVolume"
            @change="changeSpeakerVolume"
          ></el-slider>
          <div class="speaker-tips-box">
            <el-popover
              placement="bottom"
              popper-class="speaker-volume-tips-popover"
              :append-to-body="false"
              trigger="manual"
              v-model="speakerPopoverVisible"
              content="扬声器音量较低，你可能无法听到教室内的声音，建议调大音量"
            >
              <el-button
                class="speaker-tips-button"
                slot="reference"
              ></el-button>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VolumeTest from "@saas/pages/src/live/components/VolumeTest.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  components: {
    VolumeTest,
  },
  data() {
    return {
      microTestVolume: 0,
      speakerPlaying: false,
      speakerPopoverVisible: false,
      isElectron: window.isElectron,
      timeout: null,
      micEnhanceVolume: 130,
      micMarks: {
        0: "默认",
        110: "1",
        120: "2",
        130: "3",
        140: "4",
        150: "5",
      },
    };
  },

  computed: {
    ...mapState("live", [
      "liveService",
      "signConfig",
      "deviceSwtich",
      "microphoneList",
      "speakerList",
      "currentMicDevice",
      "currentSpeakerDevice",
      "userStatus",
      "audioPermission",
      "roomInfo",
    ]),
    speakerVolume: {
      get() {
        return this.$store.state.live.speakerVolume;
      },
      set(val) {
        this.setSpeakerVolume(val);
      },
    },
    ansEnabled: {
      get() {
        return this.$store.state.live.isANSEnabled;
      },
      set(val) {
        this.$store.commit('live/setIsANSEnabled', val);
      },
    },
    microphoneOptions() {
      return [
        ...this.microphoneList,
        { deviceId: "disabled", deviceName: "禁用" },
      ];
    },
    speakerOptions() {
      return [...this.speakerList];
    },
    micro: {
      get() {
        if (this.audioPermission === false) {
          return "disabled";
        } else if (this.deviceSwtich?.microphone === "on") {
          // 打开-判断打开的是什么设备
          if (
            this.currentMicDevice?.deviceId &&
            this.currentMicDevice?.deviceId !== "disabled"
          ) {
            return this.currentMicDevice?.deviceId;
          } else if (this.microphoneList?.[0]?.deviceId) {
            return this.microphoneList?.[0]?.deviceId;
          } else {
            return null;
          }
        } else {
          return "disabled";
        }
      },
      set(value) {
        this.changeMicro(value);
      },
    },
    speaker: {
      get() {
        if (this.currentSpeakerDevice?.deviceId) {
          return this.currentSpeakerDevice?.deviceId;
        } else {
          return this.speakerList?.[0]?.deviceId;
        }
      },
      set(value) {
        this.changeSpeaker(value);
      },
    },
  },
  mounted() {
    this.testSpeakerAudio = document.createElement("audio");
    this.testSpeakerAudio.src =
      process.env.VUE_APP_CDN_URL + "/cdn/static/audio/testspeak.mp3";
    this.testSpeakerAudio.addEventListener("ended", this.onTestSpeakerAudioEnd);
    this.setSpeak();
  },
  beforeDestroy() {
    this.testSpeakerAudio.pause();
    this.testSpeakerAudio.removeEventListener(
      "ended",
      this.onTestSpeakerAudioEnd
    );
    this.testSpeakerAudio = null;
    this.updateMicDeviceTest(false);
  },
  watch: {
    liveService: {
      handler(val) {
        if (val) {
          this.liveService.on("testMicVolume", (volume) => {
            if (this.micro === "disabled") {
              this.microTestVolume = 0;
            } else {
              this.microTestVolume = volume;
            }
          });
          // 同步麦克风增强的初始值
          if (this.micEnhanceVolume > 100 && typeof this.liveService.setAudioCaptureVolume === 'function') {
            this.liveService.setAudioCaptureVolume(this.micEnhanceVolume);
          }
        }
      },
      immediate: true,
    },
    "deviceSwtich.microphone": {
      handler(val) {
        if (val === "off") {
          this.updateMicDeviceTest(false);
        } else {
          this.updateMicDeviceTest(true);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", [
      "setCameraList",
      "setLiveService",
      "setWhiteBoardService",
      "setMicrophoneList",
      "setIsReady",
      "setSpeakerList",
      "setCurrentCameraDevice",
      "setCurrentMicDevice",
      "setCurrentSpeakerDevice",
      "setDeviceSwtich",
      "setSpeakerVolume",
      "setUserStatus",
    ]),
    // 切换麦克风
    changeMicro(device) {
      if (this.audioPermission === false) {
        this.$darkMessage.error("麦克风权限未开启，请开启后刷新页面重试！");
        return;
      }
      const deviceInfo = this.microphoneOptions.find(
        (item) => item.deviceId === device
      );
      this.setCurrentMicDevice(deviceInfo);
      if (device === "disabled") {
        this.liveService.muteLocalAudio({ mute: true });
        this.setDeviceSwtich({
          microphone: "off",
        });
        this.setUserStatus({
          audio_state: 2,
        });
      } else {
        // this.liveService.setCurrentMicDevice({ deviceId: device });

        if (this.userStatus.is_up_stage === 1) {
          this.liveService.muteLocalAudio({ mute: false });
        }
        this.setDeviceSwtich({
          microphone: "on",
        });
        if (
          this.userStatus.is_up_stage === 1 &&
          this.userStatus.is_send_audio === 1
        ) {
          this.setUserStatus({
            audio_state: 1,
          });
        }
      }
    },
    updateMicDeviceTest(tag) {
      if (tag) {
        this.liveService.startMicDeviceTest({
          interval: 100,
          playback: false,
        });
      } else {
        this.microTestVolume = 0;
        this.liveService.stopMicDeviceTest();
      }
    },
    changeMicEnhanceVolume(val) {
      console.log(val);
      if (
        this.liveService &&
        typeof this.liveService.setAudioCaptureVolume === "function"
      ) {
        this.liveService.setAudioCaptureVolume(val);
      }
      uploadLiveLog({
        message: "调节麦克风增强音量",
        tag: "action",
        extra: {
          component: "AudioSetting",
          action: "change_mic_enhance_volume",
          volume: val,
        },
      });
    },
    changeANS(val) {
      if (this.liveService && typeof this.liveService.enableAudioANS === 'function') {
        this.liveService.enableAudioANS(val);
      }
      uploadLiveLog({
        message: `${val ? '开启' : '关闭'}AI降噪`,
        tag: "action",
        extra: {
          component: "AudioSetting",
          action: "change_ans",
          enabled: val,
        },
      });
    },
    // 切换扬声器
    changeSpeaker(device) {
      const deviceInfo = this.speakerOptions.find(
        (item) => item.deviceId === device
      );
      this.setCurrentSpeakerDevice(deviceInfo);
      if (device === "disabled") {
        this.liveService.muteLocalAudio({ mute: true });
        this.setDeviceSwtich({
          speaker: "off",
        });
      } else {
        this.liveService.setCurrentSpeakerDevice({ deviceId: device });
        if (this.userStatus.is_up_stage === 1) {
          this.liveService.muteLocalAudio({ mute: false });
        }
        this.setDeviceSwtich({
          speaker: "on",
        });
        this.setSpeak();
      }
    },
    onClickCheckSpeaker() {
      this.speakerPlaying = true;
      // 检测扬声器
      this.testSpeakerAudio.play();
    },
    inputSpeakerVolume(val) {
      if (this.testSpeakerAudio) {
        this.testSpeakerAudio.volume = val / 100;
      }
    },
    changeSpeakerVolume(val) {
      if (val <= 10) {
        this.speakerPopoverVisible = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.speakerPopoverVisible = false;
        }, 5000);
      } else {
        this.speakerPopoverVisible = false;
      }
      // 扬声器音量只控制系统扬声器，不影响 TRTC 远端音频
      uploadLiveLog({
        message: "调节扬声器音量",
        tag: "action",
        extra: {
          component: "AudioSetting",
          action: "change_speaker_volume",
          volume: val,
        },
      });
    },
    setSpeak() {
      const deviceInfo = this.speakerOptions.find(
        (item) => item.deviceId === this.speaker
      );
      // 关键：设置测试音频的输出设备
      if (
        this.testSpeakerAudio &&
        typeof this.testSpeakerAudio.setSinkId === "function"
      ) {
        this.testSpeakerAudio
          .setSinkId(deviceInfo.realDeviceId || deviceInfo.deviceId)
          .catch((err) => {
            console.warn("setSinkId failed", err);
          });
      }
    },
    onTestSpeakerAudioEnd() {
      this.speakerPlaying = false;
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.audio-setting-component {
  .check-item {
    position: relative;
    margin-bottom: 24px;
    .check-item__title {
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
  .micro-box,
  .speaker-box {
    .test-volume {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      .el-progress {
        flex: 1;
        margin-left: 11px;
      }
      .test-volume-box {
        flex: 1;
        margin-left: 11px;
      }
      .el-slider {
        flex: 1;
        margin-left: 11px;
      }
    }
    .el-select ::v-deep {
      width: 100%;
      margin-bottom: 8px;
      background: #27272a;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px 12px 12px 12px;
      &:hover {
        background: #3f3f46;
        .el-input__inner {
          background: #3f3f46;
        }
      }
      .el-input__inner {
        background: #27272a;
        border: none;
        color: #c9cdd4;
      }
    }
    .select-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        margin: 0;
      }
      .check-btn__speaker ::v-deep {
        width: 90px;
        height: 40px;
        background: #18181b;
        border: 1px solid rgba(63, 63, 70, 0.4);
        border-radius: 12px 12px 12px 12px;
        margin-left: 12px;
        color: #ffffff;
        font-size: 14px;
        color: #e8f3ff;
        padding: 0;
        span {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }

        &:hover {
          background: #0e42d2;
        }
      }
      .check-btn__speaker--play {
        background: #0e42d2;
      }
    }
    .slider-box ::v-deep {
      flex: 1;
      .el-slider__runway {
        background: #52525b;
        height: 8px;
      }
      .el-slider__bar {
        background: #165dff;
        height: 8px;
      }
      .el-slider__button-wrapper {
        .el-slider__button {
          width: 18px;
          height: 18px;
          background: #18181b;
          border: 2px solid #165dff;
        }
      }
    }
  }
  .test-volume-speaker {
    position: relative;
    .speaker-tips-box {
      position: absolute;
      left: 73px;
      top: 16px;
      .speaker-tips-button {
        // width: 100px;
        width: 10px;
        height: 0;
        padding: 0;
        border: none;
        background: transparent;
      }
    }
  }
  .mic-enhance-box {
    margin-top: 24px;
    padding-right: 12px;
    .slider-box {
      width: 100%;
      margin-left: 8px;
    }
    .check-item__title {
      margin-bottom: 0px;
    }
  }
  .ans-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    .check-item__title {
      margin-bottom: 0;
    }
  }
}
</style>
